import { useEffect } from 'react'

import countries from 'common/utils/data/countries'
import states from 'common/utils/data/states'

import { fields as shippingFields } from './Sections/ShippingAddressFragment'
import useGenericInformationForm from './useGenericInformationForm'

const defaultWatchableFields = [
  'email',
  'phone',
  'firstName',
  'lastName',
  'recipientFirstName',
  'recipientLastName',
  'toEmail',
  'deliveryDate',
  'note',
  'billingZipCode',
  ...shippingFields,
]

const useInformationForm = (product, onSubmit, recaptcha = false, watchableFields = defaultWatchableFields) => {
  const [information, methods] = useGenericInformationForm(product, watchableFields, {
    enabled: recaptcha,
    onSubmit,
  })

  const { setValue } = methods

  useEffect(() => {
    // TODO: test do we actually need this; it is present on different pages
    if (information.country) {
      const activeCountry = countries.find((state) => state.value === information.country)

      if (activeCountry) {
        setValue('country', activeCountry.value, {
          shouldValidate: true,
        })
      }
    }

    if (information.country && information.state) {
      const activeState = states[information.country].find((state) => state.value === information.state)

      if (activeState) {
        setValue('state', activeState.value, {
          shouldValidate: true,
        })
      }
    }
  }, [information, setValue])

  return methods
}

export default useInformationForm
